import React from "react";
import { CreateTileType, EditTileType } from "./types";

export const CreateTileContext = React.createContext<CreateTileType | null>(
  null
);

export const EditTileContext = React.createContext<EditTileType | null>(null);
